















































import { Component, Mixins } from "vue-property-decorator";
import { ContentService } from "@/service/content.service";
import { AppData } from "@/models/app-data";
import CommonMixin, {
  WORKFLOW_PREFERRED_GREAT_START,
} from "@/mixins/common-mixins";
import PageLoader from "@/components/PageLoader.vue"
import { MatchNoneAndGSRPLikelyReferralContent } from "@/models/content/match-none-and-gsrp-likely-referral";

@Component({
  components: {PageLoader},
})
export default class MatchNoneAndGSRPLikelyReferral extends Mixins(CommonMixin) {
  content: MatchNoneAndGSRPLikelyReferralContent = {} as MatchNoneAndGSRPLikelyReferralContent;
  appData = {} as AppData;
  loadDataFinished = false;
  textDirection = 'ltr'

  async mounted(): Promise<void> {
    try {
      const contentService = new ContentService(this.$route);
      this.content = await contentService.getMatchNoneAndGSRPLikelyReferralContent();
      this.textDirection = contentService.TextDirection();    

      this.appData = this.getAppData();
      if (this.appData != null) {
        this.appData.preferredProgram = WORKFLOW_PREFERRED_GREAT_START;
        this.saveAppData(this.appData);

        await this.putWorkflowStep( this.appData.workflowId, "MatchNoneAndGSRPLikelyReferral") 
        await this.postWorkflowEligible(
          this.appData.workflowId,
          this.appData.preferredProgram
        );
      }
      this.loadDataFinished = true;
      this.postNavigatedToParent();
    } catch (error) {
      this.showError(error as any);
    }
  }

  disableButton(): boolean {
    return !this.loadDataFinished;
  }

    public async handleLearnMore(): Promise<void> {
    window.open( this.content.LearnMoreUrl, "_blank"); 
    await this.publishWebLearnMoreClickEvent( this.appData.workflowId) 
  }
}
